import React, { useEffect, useState } from "react";
import "../../../css/VUP_dash.css";
import { MngTgModal } from "./FxMoDetail"

export const FxMoPopup = (props) => {
  const [plantObj, setPlantObj] = useState({});
  console.log("FxMoPopup plantObj >>>", plantObj);

  useEffect(() => {
    if (props.selectedData) {
      let rowData = {};
      rowData = props?.selectedData;
      // console.log("rowData >>> ", rowData);
      if (rowData?.dataId) {
        rowData.moNo = rowData?.dataId;
      }
      setPlantObj(rowData);
    }
  }, [props.selectedData]);

  useEffect(() => {
  }, [plantObj])

  return (
    <div className="popupBasic" style={{ border: "none" }}>
      < MngTgModal plantObj={plantObj} />
    </div>
  );
}

